import React, { Component } from "react";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";
import authService from "../../../../services/login/auth.service";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";

export default class TuMetaEsLaNuestraPaso3 extends Component {

  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    datosCuenta: [],
    toggle: true,
    porSuerte: false,
    nroContrato: -1,
    cuentaOrigen: {},
    plan: {},
    idAhorro: "",
    nombreCompletoSocio: authService.getSocio().nombreCompleto.trim()
  });

  descargarContrato = async () => {
    
    await trackPromise(
      HabilitarAhorroProgramadoService.descargarContratoMeta(this.props.idAhorro)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }
  descargarComprobanteMeta = async () => {
    //console.log("DESCARGAR");


    const data = {
      titulo: "A Cuentas Propias",
      nroOperacion: this.props.idMovimiento,
      cuentaTitular: this.props.cuentaOrigen.descripcion,
      tipo: "",
      moneda:  this.props.cuentaOrigen.moneda,
      cuentaDebito: this.props.cuentaOrigen.ahorro ,
      cuentaCredito:  this.props.idAhorro,
      importeDebito:this.props.monto,
      importeCredito: this.props.monto,
      titularCuentaDestino:  this.props.cuentaOrigen.descripcion,
      idOperacion:  this.props.idMovimiento

    }
    await trackPromise(
      
      HabilitarAhorroProgramadoService.descargarComprobanteMeta(
       data
      
      )
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };




  render() {

    if (this.props.currentStep === 3) {
      mensajeExito("La Operación se Realizó Correctamente");
    }

    const columns = [
      {
        name: "concepto",
        selector: "concepto",
      },
      {
        name: "valor",
        selector: "valor",
      },
    ];

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">1</span>
                    <span className="title_text">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="number current">2</span>
                    <span className="title_text current">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">3</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8" style={{textAlign: "end"}}>
            <p className="nro-operacion">
              Cuenta de Ahorro Programado Nro: {this.props.idAhorro}                        
            </p>
          </div>
        </div>
        
        <div className="row justify-content-md-center">
          <div className="col-8">
              <section className="content">
                <div className="container-fluid"> 
                  {/* <div className="row">
                    <div className="col-md-8">
                    <label className="input-label">
                      Cuenta Origen (a debitar): 
                    </label>
                    <br/>
                      <span>
                      {this.props.cuentaOrigen.ahorro} - {this.state.nombreCompletoSocio}
                      </span>
                      <div className="inner"style={{paddingTop: 2,paddingBottom: 1,}}>
                        <h6 style={{ margin: 0 }}>
                          Tipo: {this.props.cuentaOrigen.descripcion}
                        </h6>
                        <p style={{ margin: 1 }}>
                          Moneda: {this.props.cuentaOrigen.moneda}
                        </p>
                      </div>
                    </div>                    
                  </div> */}

                  <br/>

                  <div className="row">     
                    <div className="table-responsive">
                      <table className="table">
                        <tbody>
                          <tr>
                            <th>Plan Seleccionado:</th>
                            <td>{this.props.plan.descripcion}</td>
                          </tr>
                          <tr>
                            <th>Tasa de Interés (%):</th>
                            <td>{this.props.plan.interes}</td>
                          </tr>
                          <tr>
                            <th>Importe mensual:</th>
                            <td>{this.props.monto}</td>
                          </tr>
                          <tr>
                            <th>Cuenta a debitar la cuota:</th>
                            <td>{this.props.cuentaOrigen.ahorro} - {this.props.cuentaOrigen.descripcion}</td>
                          </tr>
                          <tr>
                            <th>Importe Aproximado a Percibir:</th>
                            <td> Gs. {this.props.montoFinal}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <label
                      className="input-label-bold-obligatorio float-left">
                      (*) La tasa vigente está sujeta a variaciones
                      <br />
                    </label>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="card"
                        style={{
                          padding: 4,
                          border: "1px solid #007c34",
                          color: "rgb(58, 58, 58)",
                          boxShadow: "none",
                        }}>
                        <p>
                          Declaro bajo la fe de Juramento que los fondos de
                          todas las operaciones y transacciones que realizo
                          o realizaré con la <strong> UNIVERSITARIA LTDA. </strong>
                          durante mi vinculación comercial con la
                          Institución, cualquiera sea su naturaleza,
                          denominación, condición o modalidad de las mismas,
                          provienen y/o provendrán de fuentes lícitas
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
          </div>
        </div>

        <hr/>    
        <div className="row justify-content-md-center"> 
        <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>
          <button
            className="col-lg-3 btn btn-cu-secundary"
            style={{ marginRight: "5px" }}
            onClick={(e) => {
              this.props.returnDataPaso3();
              this.nextStep.click();
            }}
          >
            Nueva Operación
          </button>
          <button
            className="col-lg-3 btn btn-cu-primary"
            style={{ marginRight: "5px" }}
            onClick={this.descargarContrato}
          >
            Descargar Contrato
          </button>
          <button
            className="col-lg-3 btn btn-cu-primary"
            style={{ marginRight: "5px" }}
            onClick={this.descargarComprobanteMeta}
          >
            Descargar Comprobante
          </button>
        
        </div>
      </div>
    );
  }
}

